import React from "react";
import styled from "styled-components";
import { withRouter } from "react-router-dom";
import { withFirebase } from 'react-redux-firebase';

import { Button as MuiButton, Typography } from "@material-ui/core";
import { spacing } from "@material-ui/system";

const Button = styled(MuiButton)(spacing);

const Wrapper = styled.div`
  padding: ${props => props.theme.spacing(6)}px;
  text-align: center;
  background: transparent;

  ${props => props.theme.breakpoints.up("md")} {
    padding: ${props => props.theme.spacing(10)}px;
  }
`;

function Invalid({ firebase, history }) {
  return (
    <Wrapper>
      <Typography component="h1" variant="h1" align="center" gutterBottom>
        Invalid
      </Typography>
      <Typography component="h2" variant="h5" align="center" gutterBottom>
        This account is not a valid merchant account.
      </Typography>
      <Typography component="h2" variant="body1" align="center" gutterBottom>
        The server encountered something unexpected that didn't allow it to
        complete the request.
      </Typography>

      <Button
        to="/"
        variant="contained"
        color="secondary"
        mt={2}
        onClick={() => {
          firebase.logout().then(() => {
            history.push('/signin');
          }).catch(error => {
            console.log(error);
          });
        }}
      >
        Logout
      </Button>
    </Wrapper>
  );
}

export default withFirebase(withRouter(Invalid));
